import { createApiClient } from "../apiClientFactory";
import type { AccessCountByDay, RegistrationCountByDay } from "./analytics.interfaces";
import type { IAnalyticsService } from "./analytics.service";

export class AnalyticsApiService implements IAnalyticsService {
  private client = createApiClient("analytics");

  async getAccessesByDay(from: string, to: string): Promise<AccessCountByDay[]> {
    const response = await this.client.get<AccessCountByDay[]>(
      "/admin/analytics/accesses-by-day",
      { params: { from, to } }
    );
    return response.data;
  }

  async getRegistrationsByDay(from: string, to: string): Promise<RegistrationCountByDay[]> {
    const response = await this.client.get<RegistrationCountByDay[]>(
      "/admin/analytics/registrations-by-day",
      { params: { from, to } }
    );
    return response.data;
  }
}
